import React from "react";
import styled from "styled-components";
import { workExp } from "../data";
import Cards from "./Cards";
import { Container } from "./reusable_components";

const BackGroundGlow = styled.div`
  width: 100%;
  min-height: 500px;
  margin: 100px auto;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #763cac 0%,
    rgba(50, 15, 133, 0) 100%
  );
`;
const WorkExpH1 = styled.h1`
  color: #fff;
`;
const WorkExperience = () => {
  return (
    <BackGroundGlow>
      <WorkExpH1>Work Experience</WorkExpH1>
      <Container className="d-flex justify-center align-center">
        {workExp.map((data, index) => (
          <Cards data={data} key={index} />
        ))}
      </Container>
    </BackGroundGlow>
  );
};

export default WorkExperience;
